<template>
  <div class="product-links-inputs">
    <div class="d-flex flex-column ">
      <h5 class="text-semibold mb-4">{{ label }}</h5>
      <snow-input class="flex-fill" :value="url" readonly id="link-sales-page">
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-arrow-square-out"
          @click="open"
        />
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-copy"
          @click="copy"
        />
      </snow-input>
    </div>
  </div>
</template>

<script>
import copy from "copy-text-to-clipboard";

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    plan_offer: {
      type: Object,
      default: null
    },
    group: {
      type: [Number, String, Object],
      default: ""
    },
    label: {
      type: String,
      default: "Checkout"
    },
    custom_url: {
      type: String,
      default: null
    }
  },
  computed: {
    url() {
      if (this.custom_url) return this.custom_url;

      if (this.plan_offer) {
        if (this.group) {
          return this.plan_offer.url + "&group=" + this.group.id;
        }
        return this.plan_offer.url;
      }
      return this.product.url;
    }
  },
  methods: {
    copy() {
      copy(this.url);
      this.$message.success("Link copiado");
    },
    open() {
      window.open(this.url, "_blank");
    },
    toShort() {}
  }
};
</script>
